/**
 * Runtime API base resolver.
 *
 * When the app runs on the official custom domain (alfredwine.com) we use
 * same-origin requests so the frontend and backend share the same host.
 * This avoids CORS and cross-origin cookie issues even if the build-time
 * REACT_APP_BACKEND_URL still points at the legacy *.emergent.host URL.
 *
 * Everywhere else (preview, localhost, staging) we fall back to the
 * build-time REACT_APP_BACKEND_URL.
 */
const SAME_ORIGIN_HOSTS = new Set(["alfredwine.com", "www.alfredwine.com"]);

function resolveBackendUrl() {
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname;
    if (SAME_ORIGIN_HOSTS.has(host)) {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const resolveImageUrl = (url) => (!url ? "" : url.startsWith("/") ? `${BACKEND_URL}${url}` : url);
